import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { LazyImage } from 'common/react/components/LazyImage';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { useGetContentQuery } from 'common/store/modules/api/content-api';

export const ModalAflIdPromo = ({ text, buttons, trackingConfig }) => {
    const containerRef = useRef(null);
    const authButtonsSetupRef = useRef(false);
    const requestConfig = {
        type: 'PHOTO',
        params: {
            pageSize: 1,
            tagNames: 'settings-modal-afl-id-promo'
        }
    };

    const { data: modalImage } = useGetContentQuery(requestConfig);
    const imageHasTag =
        modalImage?.content[0]?.tags[0]?.label === 'settings-modal-afl-id-promo'
            ? true
            : false;

    useEffect(() => {
        if (
            containerRef.current &&
            PULSE.app.common.aflidHelpers &&
            !authButtonsSetupRef.current
        ) {
            authButtonsSetupRef.current = true;
            PULSE.app.common.aflidHelpers.setupAuthButtons({
                container: containerRef.current,
                componentName:
                    trackingConfig?.componentName ||
                    PULSE.app.common.CONSTANTS.TRACKING.COMPONENT_NAMES
                        .LOGGED_OUT_MODAL,
                customTrackingData: trackingConfig?.customTrackingData || {}
            });
        }
    }, [trackingConfig]);

    return (
        <div className="modal-afl-id-promo" ref={containerRef}>
            <div className="modal-afl-id-promo__content">
                <SvgIcon icon="afl-id-logo" className="icon" />
                <p className="modal-afl-id-promo__text">{text}</p>
                <div className="modal-afl-id-promo__buttons-container">
                    {buttons.map((button) => {
                        let action = '';
                        if (button.label.includes('Login')) {
                            action = 'login';
                        } else if (button.label.includes('Create')) {
                            action = 'register';
                        }

                        return (
                            <button
                                className="modal-afl-id-promo__button button-new button-new--neutral-inverted"
                                key={button.label}
                                data-action={action}
                                type="button"
                            >
                                {button.label}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className="modal-afl-id-promo__image-container">
                {modalImage && imageHasTag ? (
                    <LazyImage
                        url={`${modalImage.content[0].onDemandUrl}?width=270&height=480`}
                        cssClass="modal-afl-id-promo__image"
                    />
                ) : null}
            </div>
        </div>
    );
};

ModalAflIdPromo.propTypes = {
    text: PropTypes.string,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired
        })
    ),
    trackingConfig: PropTypes.shape({
        componentName: PropTypes.string,
        trackingCategory: PropTypes.string,
        customTrackingData: PropTypes.object
    })
};
